module.exports = __webpack_public_path__ + "static/fshq-team-2025-352763ca1ebe70ee0db0014779944845.png";